
import { FC } from "react";
import { useApp } from "../../../context/useApp";
import { Fieldset } from "../../../parts/inputs/Fieldset";
import { DEFAULT_DIALOG_HANDLE, MIN_AVAILABILITY_PERCENT_TO_DISPLAY_FIRE_ICON_IN_ZONES, SCREEN_BREAKPOINT_2, UNASIGNED_ZONES, CHILDREN_PER_ADULT, ZONE_ORDERS } from "../../../utils/symbols";
import { _, getEventOccupation, getSortedTickets, getZoneName, parseNum } from "../../../utils/helpers";
import { Icon } from "../../../parts/Icon";
import { DialogHandle, SafeZone, TranslationKey, ProductCategory } from "../../../types";
import { useRef} from "react";
import { ZoneCard } from "../../../parts/ZoneCard";

export const Zones: FC = () => {

    const {
        state: { tableMapHandle, booking, dialogHandles, products, layout, shifts },
    } = useApp()

    const dialogHandle:DialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    const sortedTickets = getSortedTickets(products)

    const handleFocusZone = (zone: SafeZone | 'cv', category: ProductCategory = 'adult') => {

        // changed: remove the zoom when selecting a zone
        // if (tableMapHandle.getCurrentlyFocusing() === zone) tableMapHandle.focusRect()
        // else tableMapHandle.focusRect({rect: zone})
        if (tableMapHandle.getCurrentlyFocusing() === zone) tableMapHandle.focusRect()
        else tableMapHandle.focusRect({rect: 'cv', dataFocusing: zone})

        if (zone !== 'cv' && UNASIGNED_ZONES.includes(zone)) {
            dialogHandle.openDialog({
                dialog: 'unassigned-seats',
                zone: zone,
                category,
                className: 'unassigned-seats w-100 h-100 df aic jcc'
            })
        }
    }
    
    const handleZoneInfo = (zone: SafeZone) => {

        tableMapHandle.focusRect({rect: zone})
        const description = `3zo_${zone}____${booking.venueId}` as TranslationKey
        const src = `https://cardamomo.ams3.cdn.digitaloceanspaces.com/bookings/resources/img/${zone}-${booking.venueId}.png`

        dialogHandle.openDialog({
            dialog: 'zone',
            zone: zone,
            alt: '',
            src: src,
            description: _(description),
            className: 'zone w-100 h-100 df aic jcc'
        })
    }

    const handleAddChildrensTicketClick = () => {
        // dialogHandle.openDialog({
        //     dialog: 'add-children',
        //     className: 'add-children w-100 h-100 df aic jcc',
        // })
        try {
            tableMapHandle.selectAdjacentChildrenSeat()
        } catch (err) {
            console.error(err)
            dialogHandle.openDialog({
                dialog: 'error', 
                icon: 'children',
                className: 'error w-100 h-100 df aic jcc adjacent-seat-not-found',
                title: _('3zo_child_a'), 
                message: _('3zo_there__'),
                closeButton: true
            })
        }
    }

    return (
        <Fieldset 
            id="tickets-selection" 
            className="zones mt-7"
        >
        <div 
            className="w-100" 
            aria-hidden
        >
        {sortedTickets.map(ticket => {

            const zone = ticket.zone as SafeZone
            const availability = getEventOccupation(layout.processedTables, shifts, zone).percentAvailable
            const qty = booking.getProductQty(ticket.id)
            if (ticket.category === 'children' && qty === 0) return null

            return (
                <ZoneCard 
                    key={ticket.id} 
                    role="option"
                    onClick={(event) => {
                        if (availability === 0) return
                        event.currentTarget.blur()
                        handleFocusZone(zone, ticket.category)
                    }}
                    product={ticket}
                    zone={zone}
                    active={qty > 0}
                    qty={qty}
                    availability={availability}
                />
        )})}
        </div>
        <div className="df aic jcsb child-tickets-container">
            <button
                className="button b-0 df aic text s20-500 pl-2 add-children outline-shadow r3" 
                onClick={handleAddChildrensTicketClick}
            >
                <Icon icon={'plus'} className="mr-0" style={{scale: '0.8'}} aria-hidden/>
                <Icon icon={'children'} className="mr-4 ml-3" aria-hidden/>
                {_('3zo_child__')}
            </button>
            <span className="tooltip-container">
                <Icon icon="info"/>
                <span className="tooltip bl text s14-400">{_('3zo_uptoy__')}</span>
            </span>
        </div>
        </Fieldset>
    )
}